import OverlayWindow from 'Components/OverlayWindow';
import { useCurrentPopup } from 'Components/Popups';
import useCreateModal from 'Components/Popups/useCreateModal';
import Spinner from 'Components/Spinner';
import { useEffect, useState } from 'react';
import { bulkDownloadFolder } from 'utils';

export interface BulkFolderInfo {
  id: number;
  title: string;
  onDone?: () => void;
}

export function useBulkDownloadModal() {
  return useCreateModal<BulkFolderInfo>();
}

export function BulkDownloadModal() {
  const { contextData: folder, close } = useCurrentPopup<BulkFolderInfo>();
  const [status, setStatus] = useState('pending');

  useEffect(() => {
    if (!folder) return;
    bulkDownloadFolder(folder.id, `${folder.title}.zip`, setStatus)
      .then(() => {
        close();
        folder.onDone && folder.onDone();
      })
      .catch(() => setStatus('failed'));
  }, [folder]);

  const message =
    status === 'complete'
      ? 'Starting download...'
      : status === 'failed'
      ? 'Download failed'
      : 'Preparing...';

  return (
    <OverlayWindow onClose={close} paddingSize="py-6 px-6" title={folder?.title}>
      <div className="flex flex-col items-center gap-4">
        {status !== 'complete' && <Spinner />}
        <div className="text-gray-700 text-sm">{message}</div>
      </div>
    </OverlayWindow>
  );
}
